<template>
    <div class="reservations d-flex flex-column">
        <div>
            <navigator v-on:mainFilterChanged="mainFilterChanged"></navigator>
        </div>

        <!-- <div class="col-sm-12 flexGrow1 overflow-auto" v-if="navigatorFilters && navigatorFilters.selectedView.id == 1">
            <reservations-by-departure-date :reservationMainFilters="navigatorFilters" :pagination="pagination" @paginationChanged="paginationChanged"></reservations-by-departure-date>
        </div>

        <div class="col-sm-12 flexGrow1 overflow-auto" v-if="navigatorFilters && navigatorFilters.selectedView.id == 2">
            <reservations-by-pickup-date :reservationMainFilters="navigatorFilters" :pagination="pagination" @paginationChanged="paginationChanged"></reservations-by-pickup-date>
        </div>

        <div class="col-sm-12 flexGrow1 overflow-auto" v-if="navigatorFilters && navigatorFilters.selectedView.id == 3">
            <reservations-by-sale-date :reservationMainFilters="navigatorFilters" :pagination="pagination" @paginationChanged="paginationChanged"></reservations-by-sale-date>
        </div> -->

        <div class="col-sm-12 flexGrow1 overflow-auto" >

            <component :is="selectedAreaName" :reservationMainFilters="navigatorFilters" :pagination="pagination" @paginationChanged="paginationChanged" @resetPagination="resetPagination"></component>
        </div>


    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Navigator from './Navigator'
    import ReservationsByDepartureDate from './ReservationsByDepartureDate'
    import ReservationsByPickupDate from './ReservationsByPickupDate'
    import ReservationsBySaleDate from './ReservationsBySaleDate'

    export default {
        data: function() {
            return {
                navigatorFilters:null,
                pagination:{
                    currentPage: 1,
                },
                availableAreas: [
                    {
                        componentName: 'ReservationsByDepartureDate',
                        viewId: 1
                    },
                    {
                        componentName: 'ReservationsByPickupDate',
                        viewId: 2
                    },
                    {
                        componentName: 'ReservationsBySaleDate',
                        viewId: 3
                    },
                ]
            }
        },
        created: function() {
            //if a specific reservation id is specified on URL
            if(this.$route.params.reservationId){
                let urlReservationId = this.$route.params.reservationId;
                // if(this.account.id === undefined){
                //     this.refreshAccountData().then((response) => {
                //         this.openSpecificReservation(urlReservationId)
                //     })
                // } else {
                    this.openSpecificReservation(urlReservationId)
                // }
            }

            console.log('Reservation - created hook - ' + this.$route.name);
            if(this.$route.name != 'reservationsEvent'){
                this.setSelectedEventListReservations(null)
                this.$forceUpdate()
            }

        },
        watch: {
            '$route.name': function(oldVal, newVal) {
                console.log('Watcher $route.name', oldVal, newVal);
                if(newVal === 'reservationsEvent'){
                    this.setSelectedEventListReservations(null)
                    this.$forceUpdate()
                }
            },
            '$route.params.reservationId': function (newVal, oldVal) {
                console.log('Watch $route.params.reservationId', newVal, oldVal);
                this.openSpecificReservation(newVal)
            }
        },
        computed: {
            ...mapGetters([
                'account'
            ]),
            selectedAreaName: function () {

                if(!this.navigatorFilters){
                    return this.availableAreas[0].componentName
                } else {
                    return this.availableAreas.filter(area => {
                        return area.viewId == this.navigatorFilters.selectedView.id
                    })[0].componentName
                }


            }
        },
        methods: {
            ...mapActions([
                'setSelectedReservation',
                'openModal',
                'pushReservationToStore',
                'setSelectedEventListReservations'
            ]),
            mainFilterChanged: function (selectedFilters){
                //when the filters on the navigation bar are changed (viewOptions and data range)
                this.pagination.currentPage = 1
                this.navigatorFilters = selectedFilters
            },
            resetPagination: function () {
                console.log('reset pagination');
                this.pagination.currentPage = 1
            },
            triggerModal: function(reservation, modal) {
                this.setSelectedReservation(reservation);
                this.openModal(modal);
            },
            openSpecificReservation: function(reservationId) {
                let vm = this

                axios.get('api/reservation/FindReservationBySupplier', {
                    params: {
                        supplierId: vm.account.supplierId,
                        reservationId: reservationId
                    }
                }).then((response) => {
                    if(response !== null && response !== undefined && response.status == 200){
                        if(response.data !== null){
                            //ticket exists
                            this.pushReservationToStore(response.data)
                            this.triggerModal(response.data, 'ReservationEdit');
                        } else {
                            vm.$toasted.info('Ticket #'+reservationId+' not found');
                            vm.ticketNr = null;
                        }
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            paginationChanged: function(newPagination) {
                // console.log(newPagination);
                this.pagination = newPagination
            }
        },
        components: {
            Navigator,
            ReservationsByDepartureDate,
            ReservationsByPickupDate,
            ReservationsBySaleDate
        }
    }
</script>



// WEBPACK FOOTER //
// Reservations.vue?474b1e0d